import { render, staticRenderFns } from "./BankTransactions.vue?vue&type=template&id=662ca372"
import script from "./BankTransactions.vue?vue&type=script&lang=js"
export * from "./BankTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports